import application from 'application/application';
import controller from './xml-svg.controller';

import template from './xml-svg.template.html';

application.directive('appXmlSvg', [
	function() {
		return {
			restrict: 'E',
			replace: true,
			scope: {
				size: '@?'
			},
			controller: controller,
			templateUrl: template
		};
	}
]);
